<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <!-- <p class="eyebrow">Material Request</p> -->
        <div class="header-title-row">
          <!-- <h2>Store Print Preview</h2> -->
          <div class="toolbar">
            <mat-slide-toggle color="primary" [(ngModel)]="includeSignature">
              Sign + Stamp
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <!-- <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Invoice
            </button> -->
            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
        <!-- <p class="subtext">
          ERP-ready request document with pending quantities and complete issue traceability.
        </p> -->
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div *ngIf="previewData.logo" class="page-watermark">
          <img [src]="previewData.logo" alt="Company watermark" />
        </div>

        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img *ngIf="previewData.logo; else logoFallback" [src]="previewData.logo" alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Store Department</div>
            <h1>{{ previewData.companyName }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">MATERIAL REQUEST</div>
            <p><strong>Request Code:</strong> {{ previewData.requestCode }}</p>
            <p><strong>Request Date:</strong> {{ previewData.requestDate }}</p>
            <p *ngIf="previewData.status"><strong>Status:</strong> {{ previewData.status }}</p>
            <p *ngIf="previewData.version !== '-'"><strong>Version:</strong> {{ previewData.version }}</p>
          </div>
        </div>

        <div class="overview-grid">
          <div class="overview-card">
            <span class="overview-label">Warehouse</span>
            <strong>{{ previewData.warehouseName }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Items</span>
            <strong>{{ previewData.totalItems }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Requested Qty</span>
            <strong>{{ previewData.totalRequested }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Pending Qty</span>
            <strong>{{ previewData.totalPending }}</strong>
          </div>
        </div>

        <div class="party-grid single">
          <section>
            <h3>Warehouse / Delivery Point</h3>
            <h4>{{ previewData.warehouseName }}</h4>
            <p *ngIf="previewData.warehouseAddress">{{ previewData.warehouseAddress }}</p>
          </section>
          <section *ngIf="previewData.requestRemarks !== '-'">
            <h3>Request Remarks</h3>
            <p>{{ previewData.requestRemarks }}</p>
          </section>
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>SR</th>
              <th>ITEM</th>
              <th>UOM</th>
              <th>AVAILABLE</th>
              <th>REQUESTED</th>
              <th>ISSUED</th>
              <th>PENDING</th>
              <th>REQUIRED ON</th>
              <th>ISSUE TRACE</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewData.items">
              <td class="center">{{ item.sr }}</td>
              <td>
                <div class="item-title">{{ item.productName }}</div>
                <div class="item-sub" *ngIf="item.specification">{{ item.specification }}</div>
                <div class="item-sub" *ngIf="item.remarks">{{ item.remarks }}</div>
              </td>
              <td class="center">{{ item.uom }}</td>
              <td class="right">{{ item.availableQty }}</td>
              <td class="right">{{ item.requestedQty }}</td>
              <td class="right">{{ item.issuedQty }}</td>
              <td class="right strong">{{ item.pendingQty }}</td>
              <td class="center">{{ item.requiredOn }}</td>
              <td>
                <div *ngIf="item.issueHistory.length === 0" class="trace-empty">Not issued yet</div>
                <div *ngFor="let trace of item.issueHistory" class="trace-line">
                  <strong>{{ trace.code }}</strong> · {{ trace.date }} · Qty {{ trace.qty }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="trace-section" *ngIf="previewData.issueHistorySummary.length > 0">
          <h3>Issue Summary</h3>
          <div class="trace-card-grid">
            <div class="trace-card" *ngFor="let trace of previewData.issueHistorySummary">
              <strong>{{ trace.code }}</strong>
              <span>{{ trace.date }}</span>
              <!-- <span>Qty {{ trace.qty }}</span> -->
              <small *ngIf="trace.remarks">{{ trace.remarks }}</small>
            </div>
          </div>
        </div>

        <div class="bottom-grid">
          <div class="details-block">
            <section>
              <h3>Warehouse / Delivery Point</h3>
              <h4>{{ previewData.warehouseName }}</h4>
              <p *ngIf="previewData.warehouseAddress">{{ previewData.warehouseAddress }}</p>
            </section>

            <section *ngIf="previewData.requestRemarks !== '-'">
              <h3>Request Remarks</h3>
              <p>{{ previewData.requestRemarks }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="summary-card-stack">
              <div class="summary-mini-card">
                <span class="overview-label">Requested Qty</span>
                <strong>{{ previewData.totalRequested }}</strong>
              </div>
              <div class="summary-mini-card">
                <span class="overview-label">Pending Qty</span>
                <strong>{{ previewData.totalPending }}</strong>
              </div>
            </div>

            <div class="html-sign-area">
              <div class="sign-company">For {{ previewData.companyName }}</div>
              <div class="sign-assets" *ngIf="includeSignature && (previewData.signatureImage || previewData.stampImage)">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Authorized Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || 'Authorized Signatory' }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Material Request Document</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">Generating material request preview...</p>
    </div>
  </ng-template>
</div>
